import * as React from 'react'

import { observer } from 'mobx-react'

import Localization from '~/client/src/shared/localization/LocalizationManager'
import { toast } from '~/client/src/shared/utils/toast'

import WorkflowCard from './WorkflowCard'
import WorkflowCardDataStore from './WorkflowCardData.store'
import WorkflowCardPlaceholder from './WorkflowCardPlaceholder'
import { extractWorkflowLinks, IWorkflowLinkRef } from './workflowLinks'

interface ICardProps {
  store: WorkflowCardDataStore
  link: IWorkflowLinkRef
  onOpenWorkflow?(workflowId: string): void
}

const WorkflowLinkCard = observer(
  ({ store, link, onOpenWorkflow }: ICardProps) => {
    const result = store.peekCard(link)

    if (result.state === 'absent') {
      return null
    }

    if (result.state !== 'ready') {
      return <WorkflowCardPlaceholder />
    }

    const { card } = result

    const handleOpen = () => {
      if (card.isActiveProject) {
        onOpenWorkflow?.(link.workflowId)
      } else {
        toast.info(
          Localization.translator.thisWorkflowIsInProject(card.projectName),
        )
      }
    }

    return <WorkflowCard card={card} onOpen={handleOpen} />
  },
)

interface IProps {
  store: WorkflowCardDataStore
  text: string
  onOpenWorkflow?(workflowId: string): void
}

function WorkflowLinkCards({ store, text, onOpenWorkflow }: IProps) {
  const links = React.useMemo(
    () => extractWorkflowLinks(text, window.location.host),
    [text],
  )

  if (!links.length) {
    return null
  }

  return (
    <>
      {links.map(link => (
        <WorkflowLinkCard
          key={link.workflowId}
          store={store}
          link={link}
          onOpenWorkflow={onOpenWorkflow}
        />
      ))}
    </>
  )
}

export default observer(WorkflowLinkCards)
